import {Box} from "@mui/material";
import {FriButtonIcon} from "../../icons/FriButtonIcon";

interface IVoucherTitle{
    title:string
}
export const CustomVoucherTitle = ({title}:IVoucherTitle) => {
    return (
        <Box sx={{display:"flex", marginBottom:"2rem"}}>
            <Box fontSize="1.5rem" marginRight="0.5rem">
                {title}
            </Box>
            <Box sx={{display:"flex", alignItems:"center"}}>
                <FriButtonIcon/>
            </Box>
        </Box>
    );
};